import { render, staticRenderFns } from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=template&id=44ac8a7a"
import script from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundSadWallpaper.vue?vue&type=style&index=0&id=44ac8a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports